<template>
  <div class="md-layout-item md-size-30 md-small-size-70">
    <i :class="icons"></i>
    <label style="font-size: 30 px">{{ displayText }}</label>
  </div>
</template>
<script>
export default {
  name: "Waiting-Response",
  data() {
    return {
      originText: "",
      displayText: "",
      tick: 0,
      beBreak: false,
      icons: "hourglass_empty",
    };
  },
  props: {
    msg: {
      type: String,
      default: "等待回應中",
    },
  },
  created: async function () {
    function sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    do {
      if (this.tick % 7 == 0) {
        //this.displayText = this.originText;
        this.displayText = this.msg;
      } else {
        this.displayText = this.displayText + ".";
      }
      switch (this.tick % 3) {
        case 0:
          this.icons = "fa fa-hourglass-start";
          break;
        case 1:
          this.icons = "fa fa-hourglass-half";
          break;
        default:
          this.icons = "fa fa-hourglass-end";
          break;
      }
      this.tick++;
      await sleep(1000);
    } while (!this.beBreak);
  },
  mounted() {},
  unmounted() {
    this.beBreak = true;
  },
};
</script>
